<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OHqZlD/tc-custom/9781504079860.jpg?1738388581651" alt="This image is the cover for the book Cat Wears a Noose, The Rachel Murdock Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cat Wears a Noose, The Rachel Murdock Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A drunken man is shot dead on his doorstep in this classic mystery starring the “observant [and] appealing” seventy-year-old sleuth (<i>Publishers Weekly</i>).</b><br/>  <br/> Walking home wearily from an evening spent poring over the books of the Parchly Heights Methodist Ladies’ Aid searching for a fifty-eight-cent error, Miss Jennifer Murdock becomes witness to a terrible scene: A man, stumbling drunk, arrives home—and just as he fumbles with his keys, gunfire erupts and kills him on the spot.<br/>  <br/> Jennifer is determined not to tell her sister, Rachel, anything about it. After all, Rachel considers herself a sleuth, or as Jennifer views it, a busybody who pokes her nose in places it doesn’t belong. What she doesn’t know is Rachel has just had a visit from a member of that same household, a meek eighteen-year-old taken in after she was orphaned and treated like a servant. Young Shirley has been alarmed by a series of nasty pranks—and now she’s heartbroken, and even more frightened, after finding her pet bird dead. There’s something awful going on in the house on Chestnut Street, and neither her prim and proper sister nor Det. Lt. Stephen Mayhew can stop Rachel from finding out what it is . . .<br/>  <br/> “Rachel has never yet failed to solve a murder mystery. Never before have her methods been quite so devious and unorthodox as they are in this story.” —<i>The New York Times</i><br/>  <br/> The Cat Wears a Noose <i>was previously published under the pseudonym</i><i>D.B. Olsen</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dolores Hitchens
      </h2>
      
      <p class="authorDescription body article">Dolores Hitchens (1907&ndash;1973) was a highly prolific mystery author who wrote under multiple pseudonyms and in a range of styles. A large number of her books were published under the moniker D. B. Olsen, and a few under the pseudonyms Noel Burke and Dolan Birkley, but she is perhaps best remembered today for her later novel, <I>Fool&rsquo;s Gold</I>, published under her own name, which was adapted into the film <I>Bande &aacute; part </I>directed by Jean-Luc Godard.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?233e8573